import React, { FunctionComponent, PropsWithChildren } from 'react';
import { Box } from '@material-ui/core';
import actionButtonsStyles from './ActionButtonsStyles';

export type IButtonClickAction = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => any | Promise<any>;

export interface IButtonProps {
  onClick: IButtonClickAction;
}

const ActionButtons: FunctionComponent<PropsWithChildren<any>> = ({ children }) => {
  const styles = actionButtonsStyles();

  return <Box className={styles.container}>{children}</Box>;
};

export default ActionButtons;
